export default __webpack_public_path__ + "static/website-buyer-guide-cover-8ad95200db8613315d46560380bc4165.svg";